<!--
Author: TangChen
Date: 2018-09-12
Desc: 执行结果页面，为公共组件
 -->
<template>
    <div class="comp-result comp">
        <div v-if="!result.special" class="result-con">
            <div class="register-box" :class="result.cla">
                <span class="register-img" />
                <p class="register-text">
                    {{ result.msg }}
                </p>
            </div>
            <div class="register-btn border-top" :class="result.cla">
                <span class="register-btn-msg">{{ result.btnMsg ? result.btnMsg : "" }}</span>
                <el-row v-if="result.btnL || result.btnR" :class="{ padbot: !result.btnMsg }">
                    <el-button
                        v-if="result.btnL.text"
                        type="primary"
                        v-on:click.once="eventBtn('btnL')"
                    >
                        {{ result.btnL.text }}
                    </el-button>
                    <el-button v-if="result.btnR.text" v-on:click.once="eventBtn('btnR')">
                        {{ result.btnR.text }}
                    </el-button>
                    <div v-if="result.btnR.ctd" class="count-down">
                        <span v-if="time > 0">{{ time }}</span>
                        {{ result.btnR.ctd }}
                    </div>
                </el-row>
            </div>
        </div>
        <div v-show="result.special" class="result-buy-con">
            <el-steps class="result-msg" :active="active" align-center>
                <template v-if="result.btnGroup">
                    <el-step
                        v-for="(btn, index) in result.btnGroup"
                        :key="index"
                        :icon="'el-icon-cust index0' + index"
                        :title="btn.tit"
                        :description="btn.text"
                    >
                        <i slot="prepend" class="el-icon-upload" aria-hidden="true">123123</i>
                    </el-step>
                </template>
            </el-steps>
            <el-row class="btn-group">
                <template v-if="result.btnGroup">
                    <el-col v-for="(btn, index) in result.btnGroup" :key="index" :span="8">
                        <el-button
                            v-if="btn.btn"
                            :type="index === 0 ? 'primary' : ''"
                            :class="{ 'border-blue': index === 1 }"
                            v-on:click.once="toPage(btn.url)"
                        >
                            {{ btn.btn }}
                        </el-button>
                    </el-col>
                </template>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name: "Result",
    props: {
        result: {
            type: Object,
            required: true
        },
        active: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            time: 0,
            btnMsg: ""
        };
    },
    mounted() {
        if (this.result.btnR.ctd) {
            if (this.result.btnR.time > 0) {
                this.time = this.result.btnR.time;
                this.$util.btnDisabled(this, function (_this) {
                    _this.$emit(_this.result["btnR"].event);
                });
            }
        }
    },
    methods: {
        eventBtn(v) {
            this.$emit(this.result[v].event);
        },
        toPage(val) {
            if (val === "return") {
                return this.$emit("return-page");
            }
            this.$router.push({ name: val });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-result {
    text-align: center;
    .register-box {
        padding: 30px 0 15px;
        .register-img {
            display: inline-block;
            width: 88px;
            height: 88px;
        }
        .register-text {
            padding-top: 7px;
            color: $text-color2;
            font-size: $f24;
            line-height: 40px;
        }
    }
    .transfer-msg {
        width: 600px;
        margin: 0 0 20px 415px;
        text-align: left;
        .more-remit {
            cursor: pointer;
            color: var(--color-redirect);
            line-height: 20px;
            text-align: right;
            &:hover {
                color: #1e84d1;
            }
        }
        p {
            font-size: $f16;
            line-height: 36px;
            color: var(--color-text-accent);
            &.tit {
                font-size: $f14;
            }
            span {
                color: var(--color-text-primary);
            }
            i {
                font-style: normal;
                display: inline-block;
                width: 120px;
                text-align: right;
            }
        }
    }
    .register-btn {
        padding-bottom: 29px;
        .register-btn-msg {
            color: var(--color-text-regular);
            line-height: 30px;
            padding: 19px 0 17px;
            display: block;
        }
        .el-row {
            &.padbot {
                padding-bottom: 100px;
            }
            .el-button {
                min-width: 165px;
            }
            .el-button + .el-button {
                margin-left: 20px;
            }
            .count-down {
                font-size: $f16;
                color: var(--color-text-accent);
                display: inline-block;
                margin-left: 18px;
                span {
                    color: var(--color-redirect);
                    padding: 0 2px;
                }
            }
        }
    }
    .register-box.register-success {
        .register-img {
            background: url("../../assets/img/icon-result.png") 0 0 no-repeat;
        }
    }
    .register-box.register-fail {
        .register-img {
            background: url("../../assets/img/icon-result.png") -104px 0 no-repeat;
        }
    }
    .result-buy-con {
        .result-msg {
            position: relative;
            width: 960px;
            margin: 80px auto 46px;
            .el-step__description {
                font-size: $f14;
                &.is-process,
                &.is-finish {
                    color: $text-color1;
                }
            }
            .el-step.is-horizontal .el-step__line {
                top: 35px;
                left: 65%;
                right: -35%;
            }
            .el-step__head.is-finish {
                color: $color-b;
                border-color: $color-b;
                .el-step__icon.is-icon {
                    background-color: $color-b;
                }
            }
            .el-step__icon.is-icon {
                width: 71px;
                height: 71px;
                background-color: var(--color-divided);
                border-radius: 50%;
                .el-step__icon-inner {
                    width: 47px;
                    height: 47px;
                }
                .index00 {
                    background: url($icon) -204px -34px no-repeat;
                }
                .index01 {
                    background: url($icon) -265px -34px no-repeat;
                }
                .index02 {
                    background: url($icon) -324px -36px no-repeat;
                }
            }
            .el-step__title {
                font-size: $f20;
                &.is-process {
                    color: $text-color2;
                    font-weight: normal;
                }
                &.is-finish {
                    color: $color-b;
                }
            }
        }
        .el-row.btn-group {
            width: 616px;
            margin: 0 auto;
            .el-col {
                text-align: center;
                .el-button {
                    width: 150px;
                    &.border-blue {
                        border-color: $color-b;
                        color: $color-b;
                        &:hover,
                        &:focus {
                            background-color: #e7f2fa;
                        }
                    }
                }
            }
        }
    }
}
</style>
